// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"41412c97","528":"f75a72db","615":"1c66c252"}[chunkId] + ".chunk.js";
};